import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { Subject, takeUntil } from 'rxjs';
import { RegionsTerritory } from 'src/app/core/interfaces/countryTerritory/country-territory.interface';
import { CountryStateService } from 'src/app/core/services/country-state/country-state.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';

@Component({
  selector: 'app-new-country-territory',
  templateUrl: './new-country-territory.component.html',
  styleUrls: ['./new-country-territory.component.scss']
})
export class NewCountryTerritoryComponent implements OnInit, OnChanges, OnDestroy {
  @Input() prestored_terriotory: any[];
  @Input() territory_id: string;
  @Output() triggerSelectedItems = new EventEmitter<any>();
  private _unsubscribeAll: Subject<any> = new Subject();
  country_territory_list: any[] = [];
  selected_country_territory = new FormControl([''], Validators.required);
  selected_regions: any[] = [];
  
  constructor(
    private _loaderService: LoaderService,
    private _countryStateService: CountryStateService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['prestored_terriotory']?.currentValue) {
      this.prestored_terriotory = changes['prestored_terriotory']?.currentValue;
      this.selected_regions = this.prestored_terriotory;
      this.selected_country_territory.setValue(this.selected_regions);
    }
    if (changes['territory_id']?.currentValue) {
      this.territory_id = changes['territory_id']?.currentValue;
    }
  }

  ngOnInit(): void {
    this.getCountryTerritory();

    this.selected_country_territory.valueChanges.subscribe(res => {
      this.getAllSelectedItems();
    })
  }

  getCountryTerritory() {
    this._loaderService.showLoader();
    this._countryStateService.getCountriesTerritory()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(res => {
        this.country_territory_list = res?.data;
        this.mapCountryTerritory();
        this._loaderService.hideLoader();
      }, (err) => {
        this._loaderService.hideLoader();
      })
  }

  mapCountryTerritory() {
    this.country_territory_list = this.country_territory_list.map((element: RegionsTerritory) => {
      element.expandable = false;
      element.isSelected = false;

      return element;
    })
  }

  selectAllRegionsTerritory(event: MatCheckboxChange ) {
    this.country_territory_list.forEach(element => {
      element.isSelected = event.checked;  

      if (event.checked) {
        if (element?.countries && element?.countries?.length) {
          element.countries.forEach(items => {
            element.isSelected = event.checked;
            this.selected_regions.push(items.id);
          })
        }
      } else {
        this.selected_regions = [];
      }
    });
    this.selected_country_territory.setValue(this.selected_regions);
  }

  selectRegions(event: MatCheckboxChange , index: number) {
    this.country_territory_list[index].isSelected = event.checked;
    if (this.country_territory_list[index]?.countries && this.country_territory_list[index]?.countries?.length) {
      this.country_territory_list[index].countries.forEach(items => {
        if (event.checked) {
          items.isSelected = event.checked;
          let find_index = this.selected_regions.indexOf(items.id);
          if (find_index === -1) {
            this.selected_regions.push(items.id);
          }
        } else {
          items.isSelected = event.checked;
          let find_index = this.selected_regions.indexOf(items.id);
          if (find_index > -1) {
            this.selected_regions.splice(find_index, 1);
          }
        }
      })
    }
    this.selected_country_territory.setValue(this.selected_regions);
  }

  selectIndivisual(event: MatOptionSelectionChange, region_index: number, country_index: number) {
    this.country_territory_list[region_index].countries[country_index].isSelected = event.source.selected;
    this.country_territory_list[region_index].isSelected = this.country_territory_list[region_index].countries.every(element => element.isSelected);
  }

  expand(index: number) {
    this.country_territory_list[index].expandable = !this.country_territory_list[index].expandable;
  }

  getAllSelectedItems() {
    this.triggerSelectedItems.emit(this.selected_country_territory.value);
  }

  checkSomeCompleted(index: number) {
    let check;
    let check_every = this.country_territory_list[index].countries.every(element => element.isSelected);
    if (!check_every) {
      check = this.country_territory_list[index].countries.some(element => element.isSelected);
    }
    return check;
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
